import SelectSupplierModal from "@/components/supplier/SelectSupplierModal";
import { useModalBehavior } from "@/hooks/behaviors";
import { SupplierUserSimpleListItem } from "@/types/apis";
import { Button, Form } from "antd";
import { useTranslation } from "react-i18next";

type Props = {
  /** 选择完成后的回调 */
  onSelect?: (rows?: SupplierUserSimpleListItem[]) => void;
};

export const SearchSupplier = ({ onSelect }: Props) => {
  const { t } = useTranslation("purchaseRequestManagement");
  const { open, openModal, closeModal } = useModalBehavior();

  const handleOk = (rows?: SupplierUserSimpleListItem[]) => {
    closeModal();
    if (rows && rows.length > 0) {
      onSelect?.(rows);
    }
  };

  return (
    <>
      <Form disabled={false}>
        <Button
          style={{
            marginLeft: 10,
            marginBottom: 10,
          }}
          type="primary"
          onClick={() => openModal()}
        >
          {t("从供应商库选择")}
        </Button>
        <SelectSupplierModal multiple open={open} onOkMulti={handleOk} />
      </Form>
    </>
  );
};
